import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/tsubaki-2.guide')

export const handle = {
  name: 'tsubaki-2/guide',
  track: { scene: 'model-landing', section: 'tsubaki-2' },
}

export default dynamic(getClientModule, { ssr: false })
